/**
 * HOOK PARA GERENCIAR MENSAGENS DO REACT NATIVE
 * 
 * Este hook deve ser usado no componente raiz da aplicação
 * para processar mensagens recebidas do React Native
 */

import { useEffect } from 'react';
import { WebViewResponse } from '../utils/useWebViewBridge';

/**
 * HOOK PARA PROCESSAR MENSAGENS DO REACT NATIVE
 * 
 * O que faz:
 * 1. Adiciona listeners para mensagens do React Native
 * 2. Processa cada tipo de mensagem recebida
 * 3. Executa callbacks apropriados
 * 4. Limpa listeners quando o componente é desmontado
 * 
 * Tipos de mensagens que processa:
 * - FILE_SELECTED: Arquivo foi selecionado pelo usuário
 * - DOWNLOAD_COMPLETE: Download foi concluído com sucesso
 * - ERROR: Ocorreu um erro no React Native
 * 
 * IMPORTANTE: Este hook deve ser usado apenas uma vez
 * no componente raiz da aplicação (geralmente App.tsx)
 */
export const useWebViewMessageHandler = () => {
  useEffect(() => {
    // Handler para processar mensagens do React Native
    const handleMessage = (event: MessageEvent) => {
      
      try {
        const message: WebViewResponse = JSON.parse(event.data);
                
        switch (message.type) {
          case 'FILE_SELECTED':
            // Arquivo foi selecionado no React Native
            // Chama o callback que foi armazenado quando solicitamos o arquivo
            if ((window as any).__fileSelectionCallback) {
              (window as any).__fileSelectionCallback(message.payload);
              // Remove o callback após usar (evita vazamentos de memória)
              delete (window as any).__fileSelectionCallback;
            }
            break;
            
          case 'DOWNLOAD_COMPLETE':
            // Download foi concluído com sucesso
            console.log('[WebView] Download concluído:', message.payload);
            // Aqui você pode adicionar um toast de sucesso se quiser
            break;
            
          case 'ERROR':
            // Ocorreu um erro no React Native
            console.error('[WebView] Erro:', message.payload);
            // Aqui você pode adicionar um toast de erro se quiser
            break;
            
          default:
            console.warn('[WebView] Tipo de mensagem desconhecido:', message.type);
        }
      } catch (error) {
      }
    };

    // Adiciona listeners para mensagens
    // Usamos ambos os eventos para compatibilidade
    window.addEventListener('message', handleMessage);
    document.addEventListener('message', handleMessage as any);

    // Cleanup ao desmontar o componente
    return () => {
      window.removeEventListener('message', handleMessage);
      document.removeEventListener('message', handleMessage as any);
    };
  }, []); // Array vazio = executa apenas uma vez
};
